import React from 'react'
import { StatesContext } from './StatesContext'
import PropTypes from 'prop-types'

class ServiceAreaSelector extends React.Component {
  constructor (props) {
    super(props)

    this.selectedStateNameRef = React.createRef()
    this.stateSelectorRef = React.createRef()

    this.closeTooltipTimeout = null

    this.state = {
      dropdownOpen: false,
      tooltipShowing: false
    }
  }

  componentDidMount () {
    $(this.stateSelectorRef.current).on('show.zf.dropdown', () => {
      $(this.selectedStateNameRef.current).foundation('hide')
      clearTimeout(this.closeTooltipTimeout)
      this.setState({
        dropdownOpen: true,
        tooltipShowing: false
      })
    })

    $(this.stateSelectorRef.current).on('hide.zf.dropdown', () => {
      this.setState({ dropdownOpen: false })
    })
  }

  dropdownStateIcon = () => {
    return this.state.dropdownOpen ? 'fa-angle-up' : 'fa-angle-down'
  }

  handleSelection = (stateCode) => {
    $(this.stateSelectorRef.current).foundation('close')
    this.props.executeNewSearch({ searchState: stateCode })

    if (!this.state.tooltipShowing) {
      this.setState({ tooltipShowing: true })
      $(this.selectedStateNameRef.current).foundation('show')

      this.closeTooltipTimeout = setTimeout(() => {
        $(this.selectedStateNameRef.current).foundation('hide')
        this.setState({ tooltipShowing: false })
      }, 5000)
    }
  }

  stateObj = (states) => {
    return states.find(state => state.code === this.props.searchState)
  }

  renderStateOptions = (states) => {
    const stateOptions = states.map((state) => {
      return (
        <a
          onClick={() => this.handleSelection(state.code)}
          key={state.code}
          className={`state ${this.props.searchState === state.code ? 'selected' : ''}`}
          data-state={state.code}
        >
          {state.name}
        </a>
      )
    })

    return <>{stateOptions}</>
  }

  serviceAreaTooltip = () => (
    <div>
      <b>Service area changed</b>
      <p>You can change your service area anytime from here.</p>
      <p>Changing your service area may alter your supplier search results.</p>
    </div>
  )

  render () {
    return (
      <StatesContext.Consumer>
        {
          states => (
            <div id='service-area-selector'>
              <div className='inner'>
                <div className='icon-container'>
                  <i className='fad fa-map-marker-alt' />
                </div>
                <div className='info-container'>
                  <div className='message'>
                    Displaying any business that services customers in
                    &nbsp;
                    <i
                      className='fal fa-question-circle'
                      data-tooltip
                      data-tooltip-class='tooltip service-area-info-tooltip'
                      tabIndex='1'
                      data-h-offset='-23'
                      title='All suppliers have a "service area" to indicate whether they serve customers in one state,
                  multiple states, or the whole country. Your search results are automatically filtered to ensure
                  any supplier you see serves customers in your state. This is not based on their business location.'
                    />
                  </div>
                  <div className='selected-state' data-toggle='state-selector'>
                    <div
                      className='state-name'
                      data-tooltip
                      data-position='bottom'
                      data-alignment='left'
                      data-allow-html='true'
                      data-disable-hover='true'
                      data-click-open='false'
                      data-disable-for-touch='true'
                      data-tooltip-class='tooltip service-area-changed-tooltip'
                      ref={this.selectedStateNameRef}
                      tabIndex='2'
                      title="<div>
                  <p class='header'><b>Service area changed</b></p>
                  <p>You can change your service area anytime from here.</p>
                  <p>Changing your service area may alter your supplier search results.</p>
                </div>"
                    >
                      {this.stateObj(states).name}
                    </div>
                    <div className='icon'>
                      <i className={`far ${this.dropdownStateIcon()}`} />
                    </div>
                  </div>
                </div>
                <div
                  id='state-selector'
                  className='dropdown-pane bottom float-left'
                  data-dropdown
                  data-close-on-click='true'
                  data-h-offset='-10'
                  data-v-offset='10'
                  ref={this.stateSelectorRef}
                >
                  {this.renderStateOptions(states)}
                </div>
              </div>
            </div>
          )
        }
      </StatesContext.Consumer>
    )
  }
}

ServiceAreaSelector.propTypes = {
  searchState: PropTypes.string.isRequired,
  executeNewSearch: PropTypes.func.isRequired
}

export default ServiceAreaSelector
